// @ts-nocheck
/**
 * Purabelle Bundle — Shared Core Engine
 * Fil: assets/purabelle-bundle-core.js
 *
 * Den dokumenterede, genbrugte motor bag både PDP-modulet
 * (snippets/purabelle-bundle.liquid) og den standalone bygger-side
 * (sections/purabelle-bundle-builder.liquid).
 *
 * Logikken er løftet 1:1 fra assets/purabelle-bundle.js og gjort ren
 * (uafhængig af modul-state), så begge forbrugere deler ÉN prismotor,
 * lager-/forudbestillingslogik og Horizon-native kurv-tilføjelse.
 *
 * VIGTIGT: Denne fil ÆNDRER ikke PDP-modulet. PDP'en kører uændret.
 */
(function () {
  'use strict';

  // ─── Konfiguration (kilde til sandhed for pris-stigen) ──────────────────────
  // Skal matche Shopifys automatiske mængderabat ("Mængderabet") pr. størrelse.
  const CONFIG = {
    bundlePrices: {
      '100ml': { 2: 49900, 3: 69900, 4: 79900, 5: 93500, 6: 112200 },
      '30ml':  { 2: 29900, 3: 39900, 4: 47900, 5: 59900, 6: 71900 },
      '3ml':   { 2: 4900,  3: 6900,  4: 8900,  5: 10900, 6: 12900 },
    },
    collections: { herre: 'herre', damer: 'damer' },
  };

  // ─── Pris ───────────────────────────────────────────────────────────────────
  function formatPrice(priceInOere) {
    return (priceInOere / 100).toFixed(0).replace('.', ',') + ' kr.';
  }

  // Bundle-total (øre) for en størrelse + antal. Tier 2–6 er eksakte; for 7+
  // anvendes top-tier-rabatten på hver enhed (matcher Shopify-rabat-stigen).
  function bundleTotal(size, base, qty) {
    const sizePrices = CONFIG.bundlePrices[size] || CONFIG.bundlePrices['100ml'];
    base = base || 0;
    if (qty < 2) return base * qty;
    if (sizePrices[qty]) return sizePrices[qty];
    const topTier = sizePrices[6] ? 6 : 5;
    const topDiscount = base * topTier - sizePrices[topTier];
    return base * qty - topDiscount;
  }

  // Fast tier-pris for nøjagtigt N flasker (det kunden faktisk betaler i kurven).
  function tierPrice(size, qty) {
    const sizePrices = CONFIG.bundlePrices[size] || CONFIG.bundlePrices['100ml'];
    return sizePrices[qty] || null;
  }

  function perBottle(size, base, qty) {
    if (qty < 1) return base || 0;
    return Math.round(bundleTotal(size, base, qty) / qty);
  }

  // ─── Lager / forudbestilling (1:1 fra PDP-modulet) ──────────────────────────
  function isOutOfStock(inv) {
    if (!inv) return false;
    return inv.variantInventoryManagement === 'shopify' &&
      (inv.variantInventoryQuantity <= 0 || inv.variantQuantityRuleMin > inv.variantInventoryQuantity);
  }

  function isPreorder(inv) {
    if (!inv) return false;
    // State is computed server-side (snippets/preorder-state-fields.liquid). The JS only
    // reads it. Fallback to stock+policy if state is absent. The date NEVER triggers.
    if (inv.state) return inv.state === 'preorder';
    return isOutOfStock(inv) && inv.variantInventoryPolicy === 'continue';
  }

  function isAvailable(inv) {
    return !isOutOfStock(inv);
  }

  // Maks. antal kunden kan vælge af én variant (respekterer lagerstyring).
  function maxQtyForVariant(inv) {
    inv = inv || {};
    const managed = inv.variantInventoryManagement === 'shopify';
    const denies = inv.variantInventoryPolicy !== 'continue';
    if (managed && denies) return Math.max(1, inv.variantInventoryQuantity || 0);
    return 99; // continue-selling / preorder / ustyret
  }

  // ─── Lager-index fra Liquid-injicerede <script> JSON-blokke ─────────────────
  function collectInventory(collectionHandles) {
    let data = [];
    (collectionHandles || Object.keys(CONFIG.collections)).forEach((handle) => {
      const json = document.getElementById(`${handle}-products`);
      if (!json) return;
      try {
        data = data.concat(JSON.parse(json.textContent));
      } catch (e) {
        console.warn(`Purabelle: kunne ikke parse ${handle}-products`, e);
      }
    });
    return data;
  }

  function findProductInventory(invData, productId) {
    return (invData || []).find(i => i.productId == productId);
  }

  function findVariantInventory(invData, productId, variantId) {
    const p = findProductInventory(invData, productId);
    return p ? p.variants.find(v => v.variantId == variantId) : {};
  }

  // ─── Forudbestillings-egenskaber til linje-varer (1:1 fra PDP-modulet) ──────
  function buildPreorderProperties(inv) {
    if (!isPreorder(inv)) return undefined;
    const properties = {};
    if (inv && inv.shipDate) {
      properties['Forudbestilling'] = `Sendes inden ${inv.shipDate}`;
    } else {
      properties['Status'] = 'Forudbestilling';
    }
    return Object.keys(properties).length > 0 ? properties : undefined;
  }

  // ─── Kurv (Horizon-native, ingen reload — 1:1 fra PDP-modulet) ──────────────
  async function addToCart(items) {
    const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
      .map(el => el.dataset.sectionId)
      .filter(Boolean);
    const uniqueSectionIds = Array.from(new Set(sectionIds));

    const cartAddUrl = (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add.js';

    const res = await fetch(cartAddUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items,
        sections: uniqueSectionIds.join(','),
        sections_url: window.location.pathname,
      }),
    });

    if (!res.ok) {
      let description = 'Cart fejl';
      try {
        const err = await res.json();
        description = err.description || err.message || description;
      } catch (e) { /* ignore */ }
      throw new Error(description);
    }
    return res.json();
  }

  // Genrender Horizons kurv-komponenter og åbn skuffen (ingen reload).
  function refreshCartUI(cart, addedCount, sourceProductId) {
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: cart,
        sourceId: 'purabelle-bundle-builder',
        data: {
          source: 'product-form-component',
          itemCount: addedCount,
          productId: sourceProductId || null,
          sections: (cart && cart.sections) || {},
        },
      },
    }));
    const drawer = document.querySelector('cart-drawer-component');
    if (drawer && typeof drawer.open === 'function') drawer.open();
  }

  // ─── Offentlig API ──────────────────────────────────────────────────────────
  window.PurabelleBundleCore = {
    CONFIG,
    formatPrice,
    bundleTotal,
    tierPrice,
    perBottle,
    isOutOfStock,
    isPreorder,
    isAvailable,
    maxQtyForVariant,
    collectInventory,
    findProductInventory,
    findVariantInventory,
    buildPreorderProperties,
    addToCart,
    refreshCartUI,
  };
})();
